import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    scoreCardSetting: [],
    getScoreCardSetting: {
        scoreCardMerits: [],
        scoreCardData: []
    },
    scoreMetrics: [],
    loading: false,
    error: null,
    cardId: '',
    isCreated: false,
    isMetricConfigured: false,
    errorTitle: '',
    errorDescription: ''
};
export const addScoreCardSetting = createAsyncThunk('scoreCard/addScoreCard', async (scoreCriteria, { rejectWithValue }) => {
    try {
        var uid = crypto.randomUUID();
        scoreCriteria.map((f) => f.cardId == uid);
        const response = await itwApi.post('/ScoreCard/add-score-criteria', {
            scoreCriteria
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to add score card settings');
    }
});
export const getScoreCard = createAsyncThunk('scoreCard/getScoreCard', async (id, { rejectWithValue }) => {
    try {
        const response = await itwApi.get('/ScoreCard/get-score-card', {
            params: { id }
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch score card settings');
    }
});
export const updateCriteria = createAsyncThunk('scoreCard/updateScoreCriteria', async (data, { rejectWithValue }) => {
    try {
        const response = await itwApi.put('/ScoreCard/assign-score-to-criteria', data);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to update score card criteria');
    }
});
export const configureScoreMetrics = createAsyncThunk('scoreCard/configureScoreMetrics', async (data, { rejectWithValue }) => {
    try {
        const response = await itwApi.post('/ScoreCard/add-score-metrics', data);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message || 'Failed to configure score metrics');
    }
});
export const scoreCardSlice = createSlice({
    name: 'scoreCard',
    initialState,
    reducers: {
        setCardId: (state, action) => {
            state.cardId = action.payload;
        },
        setErrorTitle: (state, action) => {
            state.errorTitle = action.payload;
        },
        setErrorDescription: (state, action) => {
            state.errorDescription = action.payload;
        },
        setIsCreated: (state) => {
            state.isCreated = !state.isCreated;
        },
        setIsMetricConfigured: (state) => {
            state.isMetricConfigured = !state.isMetricConfigured;
        },
        clearScoreCardSetting: (state) => {
            state.getScoreCardSetting = {
                scoreCardMerits: [],
                scoreCardData: []
            };
        },
        addScoreCriterion: (state, action) => {
            state.scoreCardSetting.push(action.payload);
        },
        removeScoreCriterion: (state, action) => {
            state.scoreCardSetting = state.scoreCardSetting.filter((item) => !(item.fieldAndValue.key === action.payload.key));
        },
        addCardMetrics: (state, action) => {
            state.scoreMetrics.push(action.payload);
        },
        resetScoreCriteria: (state) => {
            state.scoreCardSetting = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addScoreCardSetting.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(addScoreCardSetting.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        })
            .addCase(addScoreCardSetting.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(getScoreCard.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(getScoreCard.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.getScoreCardSetting = action.payload.data;
        })
            .addCase(getScoreCard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(configureScoreMetrics.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(configureScoreMetrics.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            state.isCreated = true;
        })
            .addCase(configureScoreMetrics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(updateCriteria.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(updateCriteria.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            state.isCreated = true;
        })
            .addCase(updateCriteria.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const { setCardId, addScoreCriterion, resetScoreCriteria, clearScoreCardSetting, setIsCreated, setIsMetricConfigured, removeScoreCriterion, setErrorTitle, setErrorDescription } = scoreCardSlice.actions;
export default scoreCardSlice.reducer;
